import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=d32d57f8&"
import script from "./Panel.vue?vue&type=script&lang=ts&"
export * from "./Panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d32d57f8')) {
      api.createRecord('d32d57f8', component.options)
    } else {
      api.reload('d32d57f8', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=d32d57f8&", function () {
      api.rerender('d32d57f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Panel.vue"
export default component.exports